import { render, staticRenderFns } from "./OrganizerTable.vue?vue&type=template&id=0bbf5512"
import script from "./OrganizerTable.vue?vue&type=script&lang=js"
export * from "./OrganizerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports